module.exports = __webpack_public_path__ + "img/studentmenu_hi.bba48729.jpg";